import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/PersonaArbitroDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(Method.DELETE, 'arbitros/' + idItem, null);
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('arbitros/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista('personas/' + idPadre + '/arbitro');
};

export const PostItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(Method.POST, 'arbitros', DTOs.saveItem(datosItem));
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'arbitros/' + datosItem.id,
    DTOs.saveItem(datosItem)
  );
};
